import { AgencyModel } from '../models/agency.model';
import { CompanyModel } from '../models/company.model';

export type InstallMethod = 'javascript' | 'wordpress' | 'wix' | 'gtm';

// path segment under /settings/integrations for each method
export const INSTALL_METHOD_SLUGS: Record<InstallMethod, string> = {
  javascript: 'dynamic-number-insertion/js',
  wordpress: 'wordpress',
  wix: 'wix',
  gtm: 'google-tag-manager',
};

// wix/wordpress install pages are feature-gated; javascript and gtm are always available
export function installMethodEligible(
  method: InstallMethod,
  agency: AgencyModel
): boolean {
  if (method === 'wix' || method === 'wordpress') {
    return !!agency?.hasFeature(method);
  }
  return !!INSTALL_METHOD_SLUGS[method];
}

/**
 * The single source of truth for "which method do we send this customer to".
 * Returns 'javascript' when the field is absent/unknown, or the method isn't
 * eligible for this agency.
 */
export function resolveInstallMethod(
  company: CompanyModel | null | undefined,
  agency: AgencyModel | null | undefined
): InstallMethod {
  const detected = company?.recommended_install_method;
  if (!detected || !INSTALL_METHOD_SLUGS[detected]) {
    return 'javascript';
  }

  return installMethodEligible(detected, agency) ? detected : 'javascript';
}

// full cross-app path for a method
export function installMethodPath(
  method: InstallMethod,
  opts: { agencyId: string; companyId?: string }
): string {
  const companyIdParam = opts.companyId ? `?company_id=${opts.companyId}` : '';
  return `/settings/a/${opts.agencyId}/settings/integrations/${INSTALL_METHOD_SLUGS[method]}${companyIdParam}`;
}
